import { useEffect, useState } from "react";
import DataTable from "../../component/DataTable";
import { Link } from "react-router-dom";
import ApiRequest from "../../helper/ApiRequest";
import { ApiEndpoints } from "../../helper/ApiEndpoints"; 
import { toast } from "react-toastify";
import AdminHeader from "../../component/AdminHeader";

const listEndpoint = ApiEndpoints.locpage.List;
const listDeletepoint = ApiEndpoints.locpage.delete;
const blogEditPath = "edit-locationpage";
const tableHeader = ["Date","Title",,"Slug"];
const tbody = ["page_city","page_title","location_page_slug"];

export default function LocationPageListing() {

  const [data, setData] = useState([]);

  const dataFetch = async () => {
    try {
      const response = await ApiRequest("GET", listEndpoint);
      const result = response.location_pages;
      setData(result);
    } catch (error) {
      console.error(error);
    }
  };

  useEffect(() => { 
    dataFetch();
  }, []);



  const handleDelete = async (locationpage_id) => {
      const payload = { locationpage_id };
      try {
        const response = await ApiRequest("POST", listDeletepoint, payload);
        toast.success(response.message)
        dataFetch();
      } catch (error) {
        console.error(error);
      }
    };

    const pagename = {
      name: 'Location Management',
      user: 'Admin',
      innerpage: 'Location  Management / Location'
    }

  return (
    <>
    <AdminHeader pagename={pagename}/>

      <div className="add-btn-section">
        <Link className="admin-add-btn" to="/add-locationpage">Add +</Link>
        <DataTable
          data={data}
          tableHeader={tableHeader}
          tbody={tbody}
          editPath={blogEditPath}
          onDelete={handleDelete}
        />
      </div>
    </>
  );
}



